import api from '@/apis/di/employeeTypeAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';

// Combo grid Loại cán bộ
export const useEmployeeTypeComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onEmployeeTypeComboboxLoadData = (payload, row, column, custom) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    payload.columns += ',employee_type_code,employee_type_id';
    if (!payload.sort) {
      payload.sort = 'employee_type_code';
    }
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const employeeTypeComboConfig = {
    data: comboboxDataRemote,
    columns: [],
    displayField: 'employee_type_code',
    valueField: 'employee_type_id',
    queryMode: 'remote',
    dropdownWidth: 500,
    comboboxLoadData: onEmployeeTypeComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    employeeTypeComboConfig,
    onEmployeeTypeComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
